export function isExtensionEqual(sourceExtension: string, targetExtension: string) {
	return sourceExtension === targetExtension;
}
